import { PiggyBank } from 'lucide-react'
import { useState } from 'react'

import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import { type MultipleSelectedValuesFilter } from '../types'
import FilterManagementDropdown from './FilterManagementDropdown'
import { filterByLabelAndValueCallback } from './utils'

const employmentStatusOptions: ComboboxFilterOption<string>[] = [
  { label: 'Active', value: 'active' },
  { label: 'Offboarded', value: 'inactive' },
  { label: 'Pending Offboarding', value: 'pending' },
]

const EmploymentStatusFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const filteredOptions = employmentStatusOptions?.filter(
    filterByLabelAndValueCallback(query)
  )
  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          { groupLabel: 'Employment Status', options: filteredOptions || [] },
        ]}
        placeholder='Search statuses to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={employmentStatusOptions || []}
          noSelectionText='Employment Status'
          pluralIdentifier='employment statuses'
        >
          <PiggyBank size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default EmploymentStatusFilter
